/*
 * Lazy Google Maps JavaScript API loader. Ensures the script is injected
 * exactly once even when multiple components request the API. Resolves the
 * global `window.google.maps` once ready. Fails softly when no key is set
 * so consumers can render a fallback (e.g. static map image).
 */
const CALLBACK_NAME = "__egr_gmaps_ready__";
let loaderPromise = null;

export const loadGoogleMaps = () => {
  if (loaderPromise) return loaderPromise;
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return Promise.reject(new Error("REACT_APP_GOOGLE_MAPS_API_KEY not set"));
  if (window.google?.maps) return Promise.resolve(window.google.maps);

  loaderPromise = new Promise((resolve, reject) => {
    window[CALLBACK_NAME] = () => resolve(window.google.maps);
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&callback=${CALLBACK_NAME}&libraries=marker&v=weekly`;
    s.async = true;
    s.defer = true;
    s.onerror = () => {
      loaderPromise = null;
      reject(new Error("Google Maps script failed to load"));
    };
    document.head.appendChild(s);
  });
  return loaderPromise;
};
